export interface TelegramUser {
  id:              number;
  first_name:      string;
  last_name?:      string;
  username?:       string;
  photo_url?:      string;
  language_code?:  string;
  is_premium?:     boolean;
}

export function getTelegramWebApp(): any {
  if (typeof window === "undefined") return null;
  return (window as any).Telegram?.WebApp ?? null;
}

export function getTelegramUser(): TelegramUser | null {
  return getTelegramWebApp()?.initDataUnsafe?.user ?? null;
}

export function isTelegramMiniApp(): boolean {
  return !!getTelegramWebApp()?.initDataUnsafe?.user;
}

export function initTelegramApp(): void {
  const twa = getTelegramWebApp();
  if (!twa) return;
  try {
    twa.ready();    // tells Telegram the app has loaded — removes the loading indicator
    twa.expand();   // request full-screen height
    twa.enableClosingConfirmation?.(); // prevent accidental swipe-to-close mid-bet
  } catch {}
}

export function getTelegramDisplayName(user: TelegramUser): string {
  const full = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return full || user.username || `User${user.id}`;
}
